var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yunxiao footer",class:{ 
    'absolute-l-b': _vm.absolute,
    'multiple-btns': _vm.multipleBtns
  }},[(!_vm.multipleBtns)?_c('van-button',{attrs:{"block":"","square":"","round":"","type":_vm.btnType,"to":_vm.to,"loading":_vm.loading,"loading-text":_vm.loadingText,"data-test":"footer-btn"},on:{"click":_vm.clickHandler}},[_vm._v("\n    "+_vm._s(_vm.btnText)+"\n  ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }